import { useEffect } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import Hero from '@/sections/Hero';
import TrustStrip from '@/sections/TrustStrip';
import Services from '@/sections/Services';
import WhyUs from '@/sections/WhyUs';
import Stats from '@/sections/Stats';
import Industries from '@/sections/Industries';
import CTA from '@/sections/CTA';

gsap.registerPlugin(ScrollTrigger);

export default function HomePage() {
  useEffect(() => {
    ScrollTrigger.refresh();
  }, []);

  return (
    <div className="min-h-screen bg-dark">
      <Navbar />
      <main>
        <Hero />
        <TrustStrip />
        <Services />
        <WhyUs />
        <Stats />
        <Industries />
        <CTA />
      </main>
      <Footer />
    </div>
  );
}
